module.exports = __webpack_public_path__ + "static/media/iconCalendarActive.b90b1a1c.svg";